// Firebase SDK kütüphanelerini import ediyoruz
// Eğer firebase kurulu değilse: npm install firebase
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Lütfen Firebase Konsolundan projenizin ayarlarını alıp buraya yapıştırın.
// Firebase Console -> Project Settings -> General -> Your apps -> SDK setup and configuration
const firebaseConfig = {
  apiKey: "AIzaSyCRBs6Qur3wnDSyF5N8wP_pv-BZkDoNyk4",
  authDomain: "heat-pump-tool.firebaseapp.com",
  projectId: "heat-pump-tool",
  storageBucket: "heat-pump-tool.firebasestorage.app",
  messagingSenderId: "429340726121",
  appId: "1:429340726121:web:ecbfb8f1cc1e44d8f963f8"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Cloud Functions servisini başlat
// "us-central1" bölgesi genellikle varsayılandır, farklı bir bölge seçtiyseniz değiştirin
const functions = getFunctions(app, "us-central1");

// Localhost geliştirme ortamı için Emülatör bağlantısı
// Bu sayede mail gönderdiğinizde isteği Google Cloud yerine yerel makinenize (emulator) atar.
if (window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  console.log("🔥 Emulator detected: Connecting functions to http://127.0.0.1:5001");
}

// Tanımladığımız fonksiyonu çağırabilmek için referans
export const sendSystemReportFunction = httpsCallable(functions, 'sendSystemReport');

export default app;
